export function recordingErrorMessage (error) {
  const messages = {
    NotAllowedError: '請允許瀏覽器存取麥克風，再重新錄音。',
    NotFoundError: '未偵測到麥克風，請確認裝置已連接。',
    NotReadableError: '麥克風無法使用，請關閉其他使用麥克風的程式後重試。',
    SecurityError: '請使用 HTTPS 或 localhost 開啟錄音功能。',
    UNSUPPORTED_BROWSER: '此瀏覽器不支援這個錄音方式，請改用一般錄音或更新瀏覽器。',
    UNSUPPORTED_LANGUAGE: '此語言不支援即時評分，請改用一般錄音。',
    BAD_TOKEN: '評分連線憑證無效，請重新開始錄音。',
    BAD_SIGNATURE: '評分連線憑證無效，請重新開始錄音。',
    EXPIRED: '評分連線憑證已過期，請重新開始錄音。',
    AUTH_REQUIRED: '請先登入，再使用即時評分。',
    TIMEOUT: '評分等待逾時，請重新開始錄音。',
    CONNECTION_CLOSED: '評分連線中斷，請重新錄音；這次錄音無法續傳。',
    NETWORK_SLOW: '網路傳送速度不足，請確認連線後重新錄音。',
    AZURE_ERROR: '語音評分服務暫時無法使用，請稍後重試。',
    SAVE_FAILED: '評分完成但儲存失敗，請重新錄音提交。',
    FFMPEG_FAILED: '音訊處理失敗，請重新錄音。',
    BAD_MESSAGE: '評分訊息格式有誤，請重新操作。',
    EMPTY_AUDIO: '沒有收到錄音內容，請確認麥克風後重試。',
    NO_SPEECH: '沒有辨識到語音，請靠近麥克風重新錄音。',
    ERS_RESULT_INVALID: '語音辨識結果或錄音編號不完整，請重新錄音。',
    MICROPHONE_ENDED: '麥克風已中斷，請確認裝置後重新錄音。',
    TOKEN_UNAVAILABLE: '目前無法建立即時評分連線，請稍後重試或改用一般錄音。'
  }
  return messages[error?.code] || messages[error?.name] || '錄音失敗，請確認麥克風與網路後重試。'
}

export function recordingError (code) {
  return Object.assign(new Error(code), { code })
}
